<template>
  <div>
    <page-navigate></page-navigate>
    <section class="ubm-hero" data-module="ubm-hero">
      <div class="ubm-hero__media" aria-hidden="true">
        <video class="ubm-hero__video" muted playsinline loop autoplay preload="metadata"></video>
      </div>
      <div class="ubm-hero__topShade" aria-hidden="true"></div>

      <div class="ubm-hero__content">
        <img class="ubm-hero__logo" src="@/assets/image/malaria/section1Logo.png"
          alt="EBC Financial Group × United to Beat Malaria" loading="eager" decoding="async" />
        <div class="ubm-hero__text">
          <h1 class="ubm-hero__title">
            <span>共同打败疟疾</span><br />
            <span>EBC与联合国基金会同行</span>
          </h1>
          <p class="ubm-hero__subtitle">超 15万人获得 EBC 帮助</p>
        </div>
      </div>
    </section>

    <section class="ubm-stat" data-module="ubm-stat">
      <div class="ubm-stat__inner">
        <div class="ubm-stat__left scroll-fade-left">
          <picture class="ubm-stat__leftMedia" aria-hidden="true">
            <source media="(max-width: 996px)" srcset="@/assets/image/malaria/section2LeftModelM.webp" />
            <img src="@/assets/image/malaria/section2LeftModel.webp" alt="" loading="lazy" decoding="async" />
          </picture>
          <div class="ubm-stat__leftShade" aria-hidden="true"></div>

          <div class="ubm-stat__leftContent">
            <h2 class="ubm-stat__title">疟疾：儿童健康最大威胁之一</h2>
            <div class="ubm-stat__desc">
              <p>
                2024年，全球85个国家预估有2.82亿例疟疾病例和61万例疟疾死亡，其中75%以上是5岁以下的儿童。</p>
            </div>
          </div>
        </div>

        <div class="ubm-stat__right scroll-fade-right">
          <div class="ubm-stat__numbers">
            <div class="ubm-stat__row">
              <div class="ubm-stat__num">
                <span class="ubm-stat__numMain">2.82</span><span class="ubm-stat__numUnit">亿例</span>
              </div>
              <div class="ubm-stat__label">感染</div>
            </div>
            <div class="ubm-stat__row">
              <div class="ubm-stat__num">
                <span class="ubm-stat__numMain">61</span><span class="ubm-stat__numUnit">万例</span>
              </div>
              <div class="ubm-stat__label">死亡</div>
            </div>
            <div class="ubm-stat__row">
              <div class="ubm-stat__num ">
                <span class="ubm-stat__numMain">75%</span><span class="ubm-stat__numUnit">+</span>
              </div>
              <div class="ubm-stat__label">儿童</div>
            </div>
          </div>

          <div class="ubm-stat__foot">
            <div class="ubm-stat__divider" aria-hidden="true"></div>
            <p class="ubm-stat__source">数据来源：世界卫生组织，《2024年世界疟疾报告》</p>
          </div>
        </div>
      </div>
    </section>

    <section class="ubm-impact" data-module="ubm-impact">
      <div class="ubm-impact__inner">
        <div class="ubm-impact__head">
          <h2 class="ubm-impact__h scroll-fade-up">联合打败疟疾</h2>
          <div class="ubm-impact__p scroll-fade-up">
            <p>联合打败疟疾是联合国基金会发起的全球性运动，汇聚世界各地的支持者，共同对抗疟疾。<br>EBC积极践行企业责任，全力支持联合国基金会打败疟疾全球运动。</p>
          </div>
        </div>

        <div class="ubm-impact__nums scroll-fade-up">
          <div class="ubm-impact__item" data-countup data-duration="1200">
            <div class="ubm-impact__num">
              <span class="ubm-impact__numMain" data-countup-value="61">61</span><span
                class="ubm-impact__numUnit">个</span>
            </div>
            <div class="ubm-impact__label">影响的国家</div>
          </div>

          <div class="ubm-impact__item" data-countup data-duration="1400">
            <div class="ubm-impact__num">
              <span class="ubm-impact__numMain" data-countup-value="4200">4200</span><span
                class="ubm-impact__numUnit">万</span>
            </div>
            <div class="ubm-impact__label">保护的人群</div>
          </div>

          <div class="ubm-impact__item" data-countup data-duration="1600">
            <div class="ubm-impact__num">
              <span class="ubm-impact__numMain" data-countup-value="132000">132000</span><span
                class="ubm-impact__numUnit">个</span>
            </div>
            <div class="ubm-impact__label">驱虫帐篷</div>
          </div>
        </div>
      </div>
    </section>

    <section class="ubm-move" data-module="ubm-move">
      <picture class="ubm-move__decor " aria-hidden="true">
        <source media="(max-width: 996px)" srcset="@/assets/image/malaria/section4BgSvgM.svg" />
        <img src="@/assets/image/malaria/section4BgSvg.svg" alt="" />
      </picture>
      <div class="ubm-move__inner ">
        <img class="ubm-move__img scroll-fade-left lazyload" src="@/assets/image/malaria/section4LeftModel.webp" alt=""
          decoding="async" />

        <div class="ubm-move__content scroll-fade-right">
          <div class="ubm-move__text">
            <h2 class="ubm-move__title">
              行动起来，一起打败疟疾
            </h2>
            <p class="ubm-move__desc">
              EBC 连续两年成为“联合打败疟疾”5公里跑的官方合作伙伴。每年世界疟疾日（4月25日）至5月10日，全球团队都会一起行动起来。欢迎您加入——跑、走、骑车、骑马，都可以。也欢迎您在平日里，转发、分享、捐赠、让更多人知道。<br/>不只有5公里才算数。每一次发声，都在帮一个孩子平安活到5岁。
            </p>
            <p class="ubm-move__desc2 subtitle-20_bold md-body-16_bold">加入我们，让疟疾在这一代终结。</p>
          </div>

          <a class="ubm-move__btn" href="https://fundraise.unfoundation.org/event/move-against-malaria-5k-2026/e766225"
            target="_blank" rel="noopener noreferrer nofollow">即刻加入</a>
        </div>
      </div>
    </section>

    <div class="ubm-5">
      <div class="scroll-fade-up">
        <p class="p1">我们在行动</p>
        <div class="ubm-5_list swiper">
          <div class="swiper-wrapper">
              <div class="ubm-5_item swiper-slide" v-for="item in newData">
                <a :href="item.url">
                  <img :src="item.thumbnail" loading="lazy" />
                </a>
                <p class="time">{{ item.published_time }}</p>
                <a :href="item.url" class="title">{{ item.post_title }}</a>
              </div>
          </div>
        </div>
      </div>
    </div>
    <page-footer></page-footer>
  </div>
</template>

<script>
import fadeAnimate from "../mixins/fadeAnimate.js";
import 'swiper/css/swiper.css'
import Swiper from 'swiper'

import {
  mapState,
} from 'vuex'
export default {
  mixins: [fadeAnimate],

  head() {
    return {
      title: 'EBC携手联合国基金会共同打败疟疾 | EBC金融集团',
      meta: [ // set meta
        {
          name: 'keyWords',
          content: '共同打败疟疾：EBC与联合国基金会同行，超 15万人获得 EBC 帮助'
        }
      ]
    }
  },
  data() {
    return {
      newData:[]
    }
  },
  computed: {

  },
  destroyed() {
  },
  created() {

  },
  mounted() {
    document.documentElement.setAttribute("data-theme", "dark");
    this.initPage()
  },
  methods: {
    initPage() {
      (function(THAT) {
        const HERO_SELECTOR = '[data-module="ubm-hero"]';
        const VIDEO_SELECTOR = ".ubm-hero__video";

        const SRC_PC = require("../assets/image/malaria/section1Video.mp4");
        const SRC_M = require("../assets/image/malaria/section1MVideo.mp4");
        const POSTER_PC = require("../assets/image/malaria/section1Bg.webp");
        const POSTER_M = require("../assets/image/malaria/section1MBg.webp");

        function isMobile() {
          return window.matchMedia && window.matchMedia("(max-width: 996px)").matches;
        }


        function setVideoSource(videoEl, src) {
          if (!videoEl) return;
          if (videoEl.dataset.src === src) return;

          videoEl.dataset.src = src;

          while (videoEl.firstChild) videoEl.removeChild(videoEl.firstChild);
          const source = document.createElement("source");
          source.src = src;
          source.type = "video/mp4";
          videoEl.appendChild(source);

          try {
            videoEl.load();
          } catch (e) {
            // no-op
          }
        }

        function tryPlay(videoEl, heroEl) {
          if (!videoEl) return;

          const onCanPlay = () => {
            heroEl && heroEl.classList.add("is-video-ready");
            const p = videoEl.play();
            if (p && typeof p.catch === "function") p.catch(() => { });
          };

          videoEl.addEventListener("canplay", onCanPlay, { once: true });

          const p = videoEl.play();
          if (p && typeof p.catch === "function") {
            p.catch(() => {
              // Autoplay may be blocked; keep image background as fallback.
            });
          }
        }

        function initHero() {
          const heroEl = document.querySelector(HERO_SELECTOR);
          if (!heroEl) return;

          const videoEl = heroEl.querySelector(VIDEO_SELECTOR);
          if (!videoEl) return;

          const apply = () => {
            const mobile = isMobile();
            setVideoSource(videoEl, mobile ? SRC_M : SRC_PC);
            tryPlay(videoEl, heroEl);
          };

          setTimeout(() => {
            apply()
          }, 500)

          let t = null;
          window.addEventListener("resize", () => {
            clearTimeout(t);
            t = setTimeout(apply, 150);
          });
        }

        function easeOutCubic(t) {
          return 1 - Math.pow(1 - t, 3);
        }

        function startCountUp(containerEl) {
          const valueEl = containerEl.querySelector("[data-countup-value]");
          if (!valueEl) return;

          const target = Number(valueEl.getAttribute("data-countup-value"));
          if (!Number.isFinite(target)) return;

          // 1. 在动画开始前，保存 DOM 里原本带有格式（如逗号分隔）的字符串
          const originalText = valueEl.textContent;
          valueEl.textContent = "0";
          const duration = Math.max(300, Number(containerEl.getAttribute("data-duration")) || 1200);

          const startTime = performance.now();
          const from = 0;
          const to = Math.round(target);

          const tick = (now) => {
            const p = Math.min(1, (now - startTime) / duration);
            const eased = easeOutCubic(p); // 假设外部已定义 easeOutCubic
            const current = Math.round(from + (to - from) * eased);

            if (p < 1) {
              // 动画进行中，显示滚动的纯数字
              valueEl.textContent = String(current);
              requestAnimationFrame(tick);
            } else {
              // 2. 动画结束后（p === 1），将值改回原始的文本（包含各种语言的标点分隔符）
              valueEl.textContent = originalText;
            }
          };

          requestAnimationFrame(tick);
        }

        function initCountUp() {
          const items = Array.from(document.querySelectorAll("[data-countup]"));
          if (!items.length) return;

          const io =
            "IntersectionObserver" in window
              ? new IntersectionObserver(
                (entries) => {
                  entries.forEach((entry) => {
                    if (!entry.isIntersecting) return;
                    const el = entry.target;
                    if (el.dataset.countupDone === "1") return;
                    el.dataset.countupDone = "1";
                    startCountUp(el);
                    io.unobserve(el);
                  });
                },
                { threshold: 0.35 }
              )
              : null;

          items.forEach((el) => {
            const valueEl = el.querySelector("[data-countup-value]");
            if (!valueEl) return;
            // Ensure visible "from" state before animation.

            if (io) io.observe(el);
            else startCountUp(el);
          });
        }
        function initSeamless() {

          const swiper = new Swiper('.ubm-5_list', {
            loop: true,             // 开启循环模式
            slidesPerView: 'auto',  // 视口展示的 slide 数量，建议设为 auto 或具体数字（如 4）
            spaceBetween: 20,       // slide 之间的间距
            speed: 6000,            // 滚动速度（毫秒），数值越大滚动越慢
            autoplay: {
              delay: 0,             // 必须为 0，确保没有停顿
              disableOnInteraction: false, // 用户手动操作后，不停止自动轮播
            },
          });
        }
        function timeRevert(timestamp){
          const date = new Date(timestamp * 1000);
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return  `${year}-${month}-${day}`;
        }
        async function getSwiperData(){
          return fetch('https://academy.ebccfd.com/api/academy-social-responsibility?lang=zh_CN&type=charity').then(res=>res.json()).then(res=>{
            res.data.list.forEach(i=>{
              i.published_time = timeRevert(i.published_time)
            })
            THAT.newData = res.data.list
          })
        //   return THAT.$http("/ebc/api/getLearnCategory/run", {
				// 	lang: 'zh_CN',
				// }).then(res => {
				// 	THAT.newData = res.data.data[0].info.slice(0,6)
				// })
        }
        async function init() {
          initHero();
          initCountUp();
          await getSwiperData()
          await THAT.$nextTick()
          initSeamless();
        }

        if (document.readyState === "loading") {
          document.addEventListener("DOMContentLoaded", init);
        } else {
          init();
        }
      })(this);

    }
  }
}

</script>

<style scoped>
/* ---- New first screen (hero) ---- */
.ubm-hero {
  position: relative;
  width: 100%;
  height: 938rem;
  background: #000 url("../assets/image/malaria/section1Bg.webp") center / cover no-repeat;
  overflow: hidden;
}

.ubm-hero__media {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.ubm-hero__video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  opacity: 0;
  transition: opacity 240ms ease;
}

.ubm-hero.is-video-ready .ubm-hero__video {
  opacity: 1;
}

.ubm-hero__topShade {
  position: absolute;
  inset: 0;
  width: 100%;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.30) 0%, rgba(0, 0, 0, 0.30) 100%);
}

.ubm-hero__content {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40rem;
  text-align: center;
  color: #fff;
  width: 100%;
  padding: 0 32rem;
}

.ubm-hero__logo {
  width: 359rem;
  height: auto;
  display: block;
}

.ubm-hero__text {
  display: flex;
  flex-direction: column;
  gap: 16rem;
  align-items: center;
}

.ubm-hero__title {
  margin: 0;
  font-size: 56rem;
  line-height: normal;
  font-weight: 700;
  white-space: nowrap;
}

.ubm-hero__subtitle {
  margin: 0;
  font-size: 28rem;
  line-height: 64rem;
  font-weight: 400;
  white-space: nowrap;
}

@media (max-width: 996px) {
  .ubm-hero {
    height: 1480rem;
    margin-top: -44px;
    background-image: url("../assets/image/malaria/section1MBg.webp");
  }

  .ubm-hero__content {
    left: 32rem;
    top: 580rem;
    transform: translateY(0%);
    width: calc(100% - 64rem);
    padding: 0;
    gap: 48rem;
  }

  .ubm-hero__logo {
    width: 384rem;
  }

  .ubm-hero__title {
    font-size: 56rem;
    line-height: 80rem;
    white-space: normal;
  }

  .ubm-hero__subtitle {
    font-size: 28rem;
    line-height: 44rem;
    white-space: normal;
  }
}

/* ---- Section 2 (Statistics) ---- */
.ubm-stat {
  background: #f7f7f7;
  padding: 120rem 0;
}

.ubm-stat__inner {
  width: 1200rem;
  margin: 0 auto;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  gap: 29rem;
}

.ubm-stat__left,
.ubm-stat__right {
  border-radius: 24rem;
  overflow: hidden;
}

.ubm-stat__left {
  position: relative;
  width: 811rem;
  height: 480rem;
  padding: 40rem;
  display: flex;
  align-items: flex-end;
}

.ubm-stat__leftMedia {
  position: absolute;
  inset: 0;
}

.ubm-stat__leftMedia img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center bottom;
  display: block;
}

.ubm-stat__leftShade {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.3);
}

.ubm-stat__leftContent {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 24rem;
  color: #fff;
}

.ubm-stat__title {
  margin: 0;
  font-size: 40rem;
  line-height: 48rem;
  font-weight: 700;
  width: 292rem;
}

.mn .ubm-stat__label {
  flex: 0 0 70%;
  white-space: wrap;
}

@media (min-width: 996px) {

  .pt .ubm-stat__title,
  .mn .ubm-stat__title,
  .ug .ubm-stat__title,
  .ru .ubm-stat__title,
  .es .ubm-stat__title,
  .en .ubm-stat__title {
    width: 450rem;
  }

  .mn .ubm-stat__numMain,
  .pt .ubm-stat__numMain {
    font-size: 48rem;
  }

  .mn .ubm-stat__numUnit,
  .pt .ubm-stat__numUnit {
    font-size: 25rem;
  }

  .ru .ubm-stat__numMain,
  .ug .ubm-stat__numMain,
  .es .ubm-stat__numMain {
    font-size: 50rem;
  }

  .ru .ubm-stat__numUnit,
  .ug .ubm-stat__numUnit,
  .es .ubm-stat__numUnit {
    font-size: 30rem;
  }
}

.ubm-stat__desc {
  font-size: 16rem;
  line-height: 24rem;
  font-weight: 400;
  width: 369rem;
  margin-top: auto;
}

.ubm-stat__desc p {
  margin: 0;
}

.ubm-stat__desc p+p {
  margin-top: 8rem;
}

.ubm-stat__right {
  width: 360rem;
  height: 480rem;
  background: #fff;
  padding: 40rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.ubm-stat__numbers {
  display: flex;
  flex-direction: column;
  gap: 24rem;
}

.ubm-stat__row {
  display: flex;
  align-items: flex-end;
  gap: 8rem;
}

.ubm-stat__num {
  color: #a52933;
  font-weight: 700;
  /* line-height: 80rem; */
}

.ubm-stat__numMain {
  font-size: 64rem;
}

.ubm-stat__numUnit {
  font-size: 32rem;
  font-weight: 800;
  margin-left: 2rem;
}

.ubm-stat__num--simple .ubm-stat__numMain {
  font-size: 64rem;
}

.ubm-stat__label {
  font-size: 16rem;
  line-height: 26rem;
  color: #364153;
  padding-bottom: 4rem;
  white-space: nowrap;
}

.ubm-stat__foot {
  display: flex;
  flex-direction: column;
  gap: 16rem;
  align-items: center;
}

.ubm-stat__divider {
  width: 100%;
  height: 1rem;
  background: rgba(0, 0, 0, 0.08);
}

.ubm-stat__source {
  margin: 0;
  font-size: 14rem;
  line-height: 22rem;
  color: rgba(0, 0, 0, 0.64);
  width: 280rem;
}

@media (max-width: 996px) {

  /* 375 design values ×2 */
  .ubm-stat {
    padding: 80rem 32rem;
  }

  .ubm-stat__inner {
    width: 100%;
    flex-direction: column;
    gap: 32rem;
  }

  .ubm-stat__left,
  .ubm-stat__right {
    border-radius: 48rem;
  }

  .ubm-stat__left {
    width: 100%;
    height: 1040rem;
    padding: 80rem;
    align-items: flex-end;
  }

  .ubm-stat__leftContent {
    gap: 48rem;
  }

  .ubm-stat__title {
    width: 100%;
    font-size: 48rem;
    line-height: 64rem;
  }

  .ubm-stat__desc {
    width: 100%;
    font-size: 32rem;
    line-height: 48rem;
  }

  .ubm-stat__desc p+p {
    margin-top: 16rem;
  }

  .ubm-stat__right {
    width: 100%;
    height: auto;
    padding: 80rem;
    gap: 48rem;
  }

  .ubm-stat__numbers {
    gap: 32rem;
  }

  .ubm-stat__num {
    line-height: normal;
  }

  .ubm-stat__numMain {
    font-size: 96rem;
    line-height: normal;
  }

  .ubm-stat__numUnit {
    font-size: 48rem;
  }

  .ubm-stat__label {
    font-size: 32rem;
    line-height: 52rem;
    padding-bottom: 12rem;
  }

  .ubm-stat__foot {
    align-items: center;
  }

  .ubm-stat__source {
    width: 100%;
    font-size: 28rem;
    line-height: 44rem;
  }
}

/* ---- Section 3 (Impact numbers) ---- */
.ubm-impact {
  background: #fff;
  padding: 120rem 0;
  text-align: center;
}

.ubm-impact__inner {
  width: 1200rem;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 64rem;
  align-items: center;
}

.ubm-impact__head {
  display: flex;
  flex-direction: column;
  gap: 16rem;
  align-items: center;
}

.ubm-impact__h {
  margin: 0;
  font-size: 40rem;
  line-height: 48rem;
  font-weight: 700;
  color: #000;
}

.ubm-impact__p {
  font-size: 18rem;
  line-height: 26rem;
  color: rgba(0, 0, 0, 0.64);
  max-width: 820rem;
}

.ubm-impact__p p {
  margin: 0;
}

/* .ubm-impact__p p + p {
  margin-top: 8rem;
} */

.ubm-impact__nums {
  width: 1200rem;
  display: flex;
  align-items: center;
}

.ubm-impact__item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12rem;
}

.ubm-impact__num {
  color: #a52933;
  font-weight: 700;
  /* line-height: 80rem; */
}

.ubm-impact__numMain {
  font-size: 64rem;
}

.ubm-impact__numUnit {
  font-size: 32rem;
  font-weight: 800;
}

.ubm-impact__label {
  font-size: 16rem;
  line-height: 26rem;
  color: #364153;
}

@media (max-width: 996px) {

  /* 375 design values ×2 */
  .ubm-impact {
    padding: 80rem 32rem 160rem;
  }

  .ubm-impact__inner {
    width: 100%;
    gap: 80rem;
  }

  .ubm-impact__head {
    width: 100%;
    gap: 16rem;
  }

  .ubm-impact__h {
    font-size: 48rem;
    line-height: 72rem;
  }

  .ubm-impact__p {
    width: 654rem;
    max-width: 100%;
    font-size: 28rem;
    line-height: 48rem;
  }

  /* .ubm-impact__p p + p {
    margin-top: 16rem;
  } */

  .ubm-impact__nums {
    width: 100%;
    flex-direction: column;
    gap: 48rem;
  }

  .ubm-impact__item {
    gap: 24rem;
  }

  .ubm-impact__num {
    line-height: normal;
  }

  .ubm-impact__numMain {
    font-size: 96rem;
    line-height: normal;
  }

  .ubm-impact__numUnit {
    font-size: 48rem;
  }

  .ubm-impact__label {
    font-size: 28rem;
    line-height: 52rem;
  }
}

/* ---- Section 4 (Move Against Malaria) ---- */
.ubm-move {
  position: relative;
  background: #fefaed;
  overflow: hidden;
}

.ubm-move__decor {
  position: absolute;
  left: -98rem;
  top: 136.92rem;
  width: 2200.5rem;
  height: 410.353rem;
  pointer-events: none;
}

.ubm-move__decor img {
  width: 100%;
  height: 100%;
  display: block;
}

.ubm-move__inner {
  position: relative;
  width: 1200rem;
  margin: 0 auto;
  padding: 120rem 0;
  display: flex;
  align-items: center;
  gap: 64rem;
  z-index: 1;
}

.ubm-move__img {
  width: 612rem;
  height: auto;
  display: block;
  border-radius: 24rem;
}

.ubm-move__content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 40rem;
  justify-content: center;
}

.ubm-move__title {
  margin: 0;
  font-size: 32rem;
  line-height: 40rem;
  font-weight: 700;
  color: #000;
  max-width: 488rem;
}

.ubm-move__desc {
  margin: 20rem 0 0;
  font-size: 14rem;
  line-height: 22rem;
  color: rgba(0, 0, 0, 0.64);
  max-width: 524rem;
}

.ubm-move__desc2 {
  color: #003B99;
  margin-top: 20rem;
}

.ubm-move__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 48rem;
  padding: 10rem 40rem;
  border-radius: 999rem;
  background: #003b99;
  color: #fff;
  font-size: 16rem;
  line-height: 28rem;
  font-weight: 500;
  text-decoration: none;
  width: max-content;
}

.ubm-move__btn:hover {
  color: #fff;
  opacity: 0.92;
}

@media (max-width: 996px) {
  .ubm-move__decor {
    left: -196rem;
    top: auto;
    bottom: 20rem;
    width: 1148.598rem;
    height: 230rem;
    transform-origin: center;
  }

  .ubm-move__inner {
    width: 100%;
    padding: 80rem 32rem 160rem;
    flex-direction: column;
    gap: 48rem;
  }

  .ubm-move__img {
    width: 100%;
    border-radius: 48rem;
  }

  .ubm-move__content {
    width: 100%;
    gap: 48rem;
    align-items: flex-start;
    text-align: center;
  }

  .ubm-move__title {
    max-width: 100%;
    font-size: 40rem;
    line-height: 56rem;
  }

  .ubm-move__desc {
    max-width: 100%;
    margin-top: 40rem;
    font-size: 28rem;
    line-height: 44rem;
  }
  .ubm-move__desc2 {
    margin-top: 40rem;
  }
  .ubm-move__btn {
    height: 96rem;
    padding: 32rem 96rem;
    font-size: 32rem;
    line-height: 56rem;
    align-self: center;
  }
}

.ubm-5 {
  padding: 120rem 0;
  overflow: hidden;
}

.ubm-5_list {
  gap: 24rem;
}

.ubm-5 .p1 {
  margin-bottom: 64rem;
  font-size: 40rem;
  font-weight: 700;
  line-height: 48rem;
  text-align: center;
}

.ubm-5 .ubm-5_item {
  flex: 0 0 400rem;
}

.ubm-5 .ubm-5_item>a>img {
  display: block;
  width: 400rem;
  height: auto;
  object-fit: cover;
  border-radius: 12rem;
}

.ubm-5 .ubm-5_item .time {
  margin: 20rem 0 8rem;
  padding: 0 8rem;
  color: rgba(0, 0, 0, 0.64);
  font-size: 14rem;
  line-height: 22rem;
  letter-spacing: 0;
  border: 0;
  float: none;
  width: auto;
}

.ubm-5 .ubm-5_item .title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 8rem;
  color: #000;
  font-size: 16rem;
  line-height: 24rem;
  font-weight: 500;
  text-decoration: none;
}

/* .ubm-5 .ubm-5_item .title:hover {
  color: #003b99;
} */
.swiper-wrapper {
  -webkit-transition-timing-function: linear !important;
  transition-timing-function: linear !important;
}

@media (max-width: 996px) {
  .ubm-5_list {
    gap: 29rem;
  }

  .ubm-5 {
    padding: 160rem 0;
  }

  .ubm-5 .p1 {
    margin-bottom: 80rem;
    font-size: 48rem;
    font-weight: 700;
    line-height: 72rem;
  }

  .ubm-5 .ubm-5_item {
    flex: 0 0 600rem;
  }

  /* 375 design values ×2 */
  .ubm-5 .ubm-5_item>a>img {
    width: 600rem;
    height: auto;
    /* 196 * 2 */
    border-radius: 21rem;
    /* 10.496 * 2 ≈ 21 */
  }

  .ubm-5 .ubm-5_item .time {
    margin: 40rem 0 16rem;
    font-size: 28rem;
    line-height: 44rem;
  }

  .ubm-5 .ubm-5_item .title {
    font-size: 32rem;
    line-height: 48rem;
  }
}
</style>
